import { App } from "vue"
import { library } from "@fortawesome/fontawesome-svg-core"
import {
    faDroplet,
    faTemperatureHalf,
    faFire,
    faPipeValve,
    faSensorCloud,
} from "@fortawesome/pro-light-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome"

library.add(faDroplet, faTemperatureHalf, faFire, faPipeValve, faSensorCloud)

export default {
    install: (app: App) => {
        app.component("FontAwesomeIcon", FontAwesomeIcon)
    },
}
